<template>
  <div class="children-day-prize-component">
    <ym-popup class="children-day-prize-popup"
              v-model="visible"
    >
      <div class="children-day-prize-container">
        <div class="children-day-prize-container-title">
          我的盲盒
        </div>
        <div v-if="!list.length"
             class="children-day-prize-container-empty"
        >
          无奖品
        </div>
        <div v-else
             class="children-day-prize-container-list"
        >
          <div v-for="(item, index) in list"
               :key="index"
               class="item"
          >
            <div class="left">{{ item.title }}x{{ item.count }}</div>
            <div class="right"
                 :class="{ 'active': item.status === 'canExchange' }"
                 @click="handleClickBtn(item)"
                 v-ym-report:MARKETING_2021CHILDRENDAY_LOTTERY_MYPRIZE_CLICK="{ title: item.title }"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';
  import { locationHref } from '@/utils';

  export default {
    name: 'MyPrizePopup',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      list: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClickBtn(item) {
        // eslint-disable-next-line default-case
        switch (item.status) {
          case 'disable':
            this.$dialog.alert({
              message: `还未集齐3张${item.title}哦~快去分享活动提高中奖几率吧！`,
              confirmButtonText: '知道了',
              closeOnClickOverlay: false,
            }).then(() => {});
            break;
          case 'exchanged':
            this.$toast('已兑换');
            break;
          case 'canExchange':
            locationHref(item.path);
            break;
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .children-day-prize {
    &-popup {
      background: none;
    }
    &-container {
      width: 600px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: @color-white;
      border-radius: 20px;
      &-title {
        width: 100%;
        height: 104px;
        color: @color-white;
        font-size: 45px;
        font-weight: @font-weight-bold;
        text-align: center;
        line-height: 104px;
        background: #f75748;
        border-radius: 20px 20px 0 0;
      }
      &-empty {
        width: 100%;
        height: 667px;
        color: #cfcfcf;
        font-size: 45px;
        font-weight: @font-weight-bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &-list {
        padding: 14px 23px 14px 38px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        width: 600px;
        .item {
          width: 100%;
          height: 88px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 14px;
          padding-right: 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #c73c30;
          &:last-child {
            border-bottom: none;
          }
          .left {
            color: #f75748;
            font-size: 30px;
            font-weight: @font-weight-bold;
          }
          .right {
            width: 150px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: @color-white;
            font-size: @font-size-base;
            border-radius: 24px;
            box-sizing: border-box;
            background: #c9c9c9;
            &.active {
              background: linear-gradient(0deg, #ff4c29 0%, #ffac68 100%);
            }
          }
        }
      }
    }
  }
</style>
